export const emailFormTestIds = {
  recipientField: (fieldName: string) => `email-recipient-field-${fieldName}`,
  sendButton: 'email-share-send-button',
};
